import { Button } from "@components/ui/button";
import { Skeleton } from "@components/ui/skeleton";
import { X } from "lucide-react";
import { useTranslations } from "next-intl";

interface IPopupContentLoader {
  name: string;
  region: string;
  clear?: () => void;
}

export function PathPopupContentLoader({
  name,
  region,
  clear,
}: IPopupContentLoader) {
  const t = useTranslations("Map");
  return (
    <div className="items-top flex flex-col justify-start gap-4 p-4 md:p-0">
      <div className="mt-10 flex flex-row justify-between md:mt-0">
        <div className="flex flex-col">
          <p className="text-lg font-bold">{name}</p>
          <p>{region}</p>
          <Skeleton className="mt-3 h-4 w-40" />
        </div>
        <div className="control flex flex-col items-end justify-between align-bottom">
          {clear && (
            <Button onClick={clear} size="xs" className="rounded-full">
              <X className="h-5 w-5" />
              <span className="sr-only">{t("Clear")}</span>
            </Button>
          )}
          <Skeleton className="mt-auto h-8 w-8 rounded-full" />
        </div>
      </div>

      <Skeleton className="aspect-video w-full" />
      <div className="content flex flex-col gap-5 text-sm">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
      </div>
    </div>
  );
}
